import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  isMobile,
  UnderMaintenanceWr,
  ConnectionPopupsWr,
  UnderMaintenanceContainer,
  useSoundWatcher,
} from '@pascal/pascal-core';

import { WebMainWrapper } from '../../web';
import { MobileMainWrapper } from '../../mobile';
import { useVisibilityChange } from '../../../hooks/useVisibilityChange';

const GameWebMobileContainer = observer(() => {
  useVisibilityChange();
  useSoundWatcher();

  return (
    <UnderMaintenanceContainer>
      <>
        {isMobile() ? <MobileMainWrapper /> : <WebMainWrapper />}
        <UnderMaintenanceWr />
        <ConnectionPopupsWr />
      </>
    </UnderMaintenanceContainer>
  );
});

export default GameWebMobileContainer;
